package com.anjuros.website.pages.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.sections.blogarticle.BlogArticlePage
import com.anjuros.website.templates.selection.modules.BlogCard
import com.varabyte.kobweb.core.Page

@Page("how-much-does-a-website-cost-for-a-sole-trader")
@Composable
fun HowMuchDoesAWebsiteCostForASoleTrader() {
    BlogArticlePage(BlogCard.BLOG4)
}
